import { makeStyles } from '@material-ui/styles'
import Theme from '@refera/ui-core'

export default makeStyles(({ spacing }) => ({
  content: {
    display: 'flex',
    width: '100%',
  },

  tableWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
  },

  tableContent: {
    display: 'grid',
    gridTemplateRows: 'repeat(2, 1fr)',
    gridTemplateColumns: 'repeat(4, 1fr)',
    rowGap: spacing(20),
    columnGap: spacing(20),
  },

  gridCell: {
    display: 'inline-flex',
    alignItems: 'center',
  },

  rightCell: {
    justifyContent: 'flex-end',
    textAlign: 'right',
  },

  label: {
    fontSize: spacing(14),
    fontWeight: Theme.Typography.FontWeight.Medium,
    color: Theme.Colors.Grayscale.Eighty,
    marginBottom: 0,
    '&.Mui-disabled': {
      color: '#9E9E9E !important',
    },
  },

  mainValueContainer: {
    display: 'flex',
    marginLeft: 'auto',
    alignItems: 'center',
  },

  mainValueLabel: {
    display: 'flex',
    alignItems: 'center',
    whiteSpace: 'nowrap',
  },

  totalValue: {
    fontSize: spacing(20),
    color: Theme.Colors.Primary.Base,
    fontWeight: Theme.Typography.FontWeight.Medium,
    marginLeft: spacing(8),
  },
  value: {
    fontSize: spacing(14),
    fontWeight: 600,
    color: Theme.Colors.Primary.Base,
  },

  meta: {
    fontSize: spacing(14),
    color: Theme.Colors.Grayscale.SixtyFour,
  },
  positiveValue: {
    color: Theme.Colors.Green.Base,
  },

  negativeValue: {
    color: Theme.Colors.Red.Base,
  },
}))
